<template>
  <div>
      <b-container fluid style="padding-top: 100px;">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
      <b-row>
          <b-col cols="12">
            <b-breadcrumb style="    background-color: #e9ecef78;">

                <b-breadcrumb-item href="#home">
                  <router-link to="/Assamese">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                    মূখ্যপৃষ্ঠা
                    </router-link>
                </b-breadcrumb-item>

               <b-breadcrumb-item href="#" active>নথি</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <Cards/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Cards from '@/components/AS_DocumentCardComponents.vue'
import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'


export default {
  name: 'Document',
  components: {
    'Cards' : Cards,
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
  }
}
</script>
<style>
.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
  @font-face {
    font-family: Assamese_Font;
    src: url("../assets/Assamese_font/KirtanUni.ttf");
  }
  div{
      font-family: arial,Assamese_Font;
  }
</style>
